import React, { FunctionComponent } from 'react';

import { PaymentDateStep as CommonPaymentDate } from 'scenes/common/components/Steps';

import { HomeFullPageProps } from 'scenes/home/types';
import {
  getPolicyStartDate,
  getPaymentDate,
  getFirstInstalment,
  getMonthlyInstalment,
  getPaymentDateOptions,
  getPaymentFrequency,
} from 'scenes/home/selectors';

const PaymentDateStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
  onNext,
  onUpdatePaymentDate,
}) => (
  <CommonPaymentDate
    defaultStateValue={getPaymentDate(funnelState)}
    policyStartDate={getPolicyStartDate(funnelState)}
    paymentDateOptions={getPaymentDateOptions(funnelState)}
    paymentFrequency={getPaymentFrequency(funnelState)}
    firstInstalment={getFirstInstalment(funnelState)}
    monthlyInstalment={getMonthlyInstalment(funnelState)}
    onNext={onNext}
    onUpdatePaymentDate={onUpdatePaymentDate}
  />
);

export default PaymentDateStep;
